const isAnonymousUser = userType => userType === "ANONYMOUS_USER";

export default isAnonymousUser;
